var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.999,
    viewBox: "0 0 54.74 55.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .a {\r\n                isolation: isolate;\r\n            }\r\n\r\n            .cls-1 {\r\n                fill: #fff;\r\n            }\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", {
    id: "on"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.11,3.32v8.07a20.38,20.38,0,1,1-23.67.13c.12-2.76.25-5.52.37-8.28a27.37,27.37,0,1,0,23.3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.33,24.68c0,2.22-1.54,4-3.43,4s-3.44-1.82-3.44-4V4c0-2.22,1.55-4,3.44-4s3.43,1.82,3.43,4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.1de6b3c45ab6e815b52643f0382a506c.svg";
export { ForwardRef as ReactComponent };